//const Backofficebff: string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const SearchServiceCommand: any = {
    PostGetSearchInformation: Backofficebff + '/v1/productstocks/getoptionids',
    GetStockByProduct: Backofficebff + '/v1/productstocks/getstockbyproduct',
    InventoryLastSync: Backofficebff + '/v1/productstocks/updateinventorylastsync',
    GetOptionSummary: Backofficebff + '/v1/productstocks/getoptionsummaries',
    GetSummariesHistory: Backofficebff + '/v1/productstocks/get-summaries-histories',
    GetProductAvailableStock: Backofficebff + '/v1/productstocks/get-product-available-stock',
    GetBarcodeBySpecialAndColorCodeList: Backofficebff + '/v1/productstocks/get-barcode-by-specialandcolorcode-list',
};
